import { getInfoNavigator } from '../../helpers/navigator'
import http from '@/http'

export const getFullInfo = uuid => {
  return http.get(`/external/${uuid}`)
    .then(response => response.data)
}

export const getRecovery = idEmail => {
  return http.get(`/external-purged/${idEmail}`)
    .then(response => response.data)
}

export const trackingReadSMS = async smsQuery => {
  const infoNavigator = await getInfoNavigator()
  return http.post('/tracking', { smsQuery, infoNavigator })
}



// WEBPACK FOOTER //
// ./src/app/external/external.service.js